import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import { useIsSystemAdmin } from "@/hooks/useIsSystemAdmin";
import { useIsTenantAdmin } from "@/hooks/useIsTenantAdmin";
import { LoadingSpinner } from "@/components/loading/LoadingSpinner";
import { toast } from "@/utils/toast";

export const Route = createFileRoute("/admin/tenants")({
  component: TenantsLayout,
});

export function TenantsLayout() {
  const { t } = useTranslation(["admin"]);
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const { isSystemAdmin, isLoading: isAdminLoading } = useIsSystemAdmin();
  const { isTenantAdmin, isLoading: isTenantAdminLoading } = useIsTenantAdmin();
  const hasRedirected = useRef(false);

  const isAuthLoading = isAdminLoading || isTenantAdminLoading;

  useEffect(() => {
    if (isAuthLoading || hasRedirected.current || !isLoggedIn) return;
    if (!isSystemAdmin && !isTenantAdmin) {
      hasRedirected.current = true;
      toast.error(t("admin:tenants.unauthorizedPageAccess"));
      navigate({
        to: "/home",
        search: { redirect: undefined, downloadJobId: undefined },
      });
    }
  }, [isAuthLoading, isLoggedIn, isSystemAdmin, isTenantAdmin, navigate, t]);

  if (isAuthLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner size="64px" />
      </div>
    );
  }

  if (!isSystemAdmin && !isTenantAdmin) {
    return null;
  }

  return <Outlet />;
}
